<template>
  <b-card no-body>
    <b-card-body>
      <div class="text-right">
        <b-button
          variant="primary"
          :to="$route.path + '/customer-search'"
        >
          <FeatherIcon icon="PlusIcon" /> Oluştur
        </b-button>
      </div>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(customer_company)="data">
        <div class="font-weight-bold">
          {{ data.item.customer_company }}
        </div>
        <div class="font-small-3 text-primary">
          {{ data.item.customer_name }}
        </div>
      </template>
      <template #cell(sdate)="data">
        <div class="font-small-3 text-primary">
          <strong>Başlangıç:</strong>
          {{ data.item.sdate? moment(data.item.sdate).format('DD.MM.YYYY') : '-' }}
        </div>
        <div class="font-small-3 text-primary">
          <strong>Teslim:</strong> {{ data.item.edate? moment(data.item.edate).format('DD.MM.YYYY') : '-' }}
        </div>
      </template>
      <template #cell(service_type)="data">
        <b-badge
          :variant="data.item.service_type_variant"
          class="w-100"
        >
          {{ data.item.service_type }}
        </b-badge>
      </template>
      <template #cell(service_status)="data">
        <b-badge
          :variant="data.item.service_status_variant"
          class="w-100"
        >
          {{ data.item.service_status }}
        </b-badge>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-dropdown-buttons
            :primary-action="$route.path + '/view/' + data.item.id"
            primary-text="Görüntüle"
            :data-id="data.item.id"
            :delete-action="removeData"
            :edit-action="$route.path + '/edit/' + data.item.id"
            edit-text="Güncelle"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ListDropdownButtons from '@/layouts/components/common/ListDropdownButtons.vue'

const tableName = 'services'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BBadge,
    ListDropdownButtons,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'customer_company',
          label: 'MÜŞTERİ',
        },
        {
          key: 'sdate',
          label: 'TARİH',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'service_type',
          label: 'HİZMET ŞEKLİ',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'service_status',
          label: 'DURUM',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.sdate AS sdate`,
          `${tableName}.edate AS edate`,
          'customers.company AS customer_company',
          'customers.name AS customer_name',
          'service_types.title AS service_type',
          'service_types.variant AS service_type_variant',
          'service_statuses.title AS service_status',
          'service_statuses.variant AS service_status_variant',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['services/dataList']
    },
    dataCounts() {
      return this.$store.getters['services/dataCounts']
    },
    saveData() {
      return this.$store.getters['services/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('services/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('services/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
